<template>
    <card v-bind="cardProps">
        <alert v-if="isClubVerified && isAccountVerified" type="success" no-spacing vertical :content="$t('text.club.verification.verified', {name: model.display_name})"/>
        <alert v-else-if="onlyPayoutAccountRequired" type="success" no-spacing vertical :content="$t('text.club.verification.payouts_disabled_verified', {name: model.display_name})" :button="$t('action.add')" :to="`${$config.public.teamsUrl.replace('{team}', model._key)}/edit/billing/bank-accounts`" :button-icon="icons.create"/>
        <template v-else-if="!isAccountVerified">
            <alert v-if="account.payouts_enabled" no-spacing vertical
                   :content="account.requirements && account.requirements.disabled_reason === 'requirements.pending_verification' ? $t('text.club.verification.payouts_pending', {name: model.display_name}) : $t('text.club.verification.payouts_enabled_unverified', {name: model.display_name})"
                   :to="`${$config.public.teamsUrl.replace('{team}', model._key)}/edit/verification`" :button-icon="icons.edit"
                   :button="account.requirements && account.requirements.disabled_reason === 'requirements.pending_verification' ? null : $t('action.verify_account')"/>
            <alert v-else-if="account.requirements" no-spacing type="warning" vertical
                   :to="`${$config.public.teamsUrl.replace('{team}', model._key)}/edit/verification`" :button-icon="icons.edit"
                   :button="account.requirements.past_due && account.requirements.past_due.length ? $t('action.verify_account') : null">
                <p v-if="account.requirements.disabled_reason === 'requirements.pending_verification'" class="mb-0">{{ $t('text.club.verification.payouts_pending', {name: model.display_name})
                    }}</p>
                <p v-else-if="account.requirements.past_due && account.requirements.past_due.length" class="mb-0">{{ $t('text.club.verification.payouts_disabled_unverified', {name:
                    model.display_name}) }}</p>
                <p v-else-if="account.requirements.currently_due && account.requirements.currently_due.length" class="mb-0">{{ $t('text.club.verification.payouts_disabled_verified', {name:
                    model.display_name}) }}</p>
            </alert>
        </template>
        <alert v-else-if="!isClubVerified" type="warning" no-spacing vertical :content="$t('text.club.verification.resultastic_unverified', {name: model.display_name})"/>
    </card>
</template>

<script>
import {CardMixin} from "@spoferan/nuxt-spoferan/mixins";
import {createIcon} from "@spoferan/nuxt-spoferan/icons";
import {editIcon} from "@spoferan/nuxt-spoferan/icons";

export default {
        name: 'VerificationInfo',

        mixins: [CardMixin],

        props: {
            model: {
                type: Object,
                required: true
            },

            account: {
                type: Object,
                required: true
            }
        },

	data() {
			return {
				icons: {
					create: createIcon,
					edit: editIcon,
				}
			}
	},

        computed: {
            onlyPayoutAccountRequired() {
                return this.account && this.account.requirements && this.account.requirements.past_due && this.account.requirements.past_due.length === 1 && this.account.requirements.past_due[0] === 'external_account'
            },

            isClubVerified() {
                return this.model.model_name !== 'club' || this.model.verified;
            },

            isAccountVerified() {
                return this.model.stripe_verified;
            }
        }
    }
</script>